export default __webpack_public_path__ + "static/media/bg4.2ca2e0bf.png";